import axios from 'axios';

const API_BASE_URL = (() => {
  const url = import.meta.env.VITE_BASE_URL;
  if (!url) {
    if (import.meta.env.DEV) {
      console.warn('Missing VITE_BASE_URL, falling back to localhost');
      return 'http://127.0.0.1:8000';
    }
    throw new Error('VITE_BASE_URL is not defined');
  }
  return url.replace(/\/$/, '');
})();

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// Request interceptor to add auth token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;